import React from 'react';
import { Box, Flex } from '@mantine/core';
import { FilterCategory } from '../types';
import { SelectedFilterContentProps } from '../components/right-panel/SelectedFilterContent';
import { ChildFilterItem } from '../components/left-panel/ChildFiltersDropdown';
import LeftPanelManageFilters from './LeftPanelManageFilters';

export interface ManageFilterModalContainerProps extends SelectedFilterContentProps {
  ideaCategories: FilterCategory[];
  evidenceCategories: FilterCategory[];
  getCategoryTooltip: (categoryId: string, disabled: boolean) => string;
  getCategoryIcon: (categoryId: string) => React.ReactNode;
  handleCategorySelect: (categoryId: string, categoryType: 'idea' | 'evidence') => void;
  childFilters: ChildFilterItem[];
  categoryIdsWithChildren: Set<string>;
  searchInput: React.ReactNode;
  handleChildFilterSelect: (childFilterId: string) => void;
  middlePanelSearch: string; 
  isFromIdeas?: boolean;
  filterVisibility: Record<string, boolean>;
  onToggleVisibility: (filterId: string) => void;
}

const ManageFilterModalContainer: React.FC<ManageFilterModalContainerProps> = ({
  ideaCategories,
  evidenceCategories,
  getCategoryTooltip,
  getCategoryIcon,
  handleCategorySelect,
  selectedCategory,
  childFilters,
  categoryIdsWithChildren,
  searchInput,
  handleChildFilterSelect,
  middlePanelSearch,
  isFromIdeas = false,
  filterVisibility,
  onToggleVisibility,
}) => {
  return (
    <Box className="filter-modal-container">
      <Flex justify="space-between" w="100%" wrap="nowrap" gap={0}>
        <Box className="filter-modal-container__left" py={12}>
          <LeftPanelManageFilters
            ideaCategories={ideaCategories}
            evidenceCategories={evidenceCategories}
            getCategoryTooltip={getCategoryTooltip}
            getCategoryIcon={getCategoryIcon}
            handleCategorySelect={handleCategorySelect}
            selectedCategory={selectedCategory}
            childFilters={childFilters}
            categoryIdsWithChildren={categoryIdsWithChildren}
            searchInput={searchInput}
            handleChildFilterSelect={handleChildFilterSelect}
            middlePanelSearch={middlePanelSearch}
            isFromIdeas={isFromIdeas}
            filterVisibility={filterVisibility}
            onToggleVisibility={onToggleVisibility}
          />
        </Box>
        <Box className="filter-modal-container__right" px={16} py={12}>
        </Box>
      </Flex>
    </Box>
  );
};

export default ManageFilterModalContainer;